module.exports = __webpack_public_path__ + "media/bootstrap-icons/shield-fill-x-6decb854.svg";